import Joi from 'joi-browser';
import * as _ from 'lodash';
import regex from './validateRegex';

/**
 * @description joiを使ってバリエーション
 * @param {Object} schema joiの型定義オブジェクト
 * @param {Any} data バリエーションするデータ
 */
export const validateByJoi = (schema, data) => {
  const result = Joi.validate(data, schema, {
    abortEarly: false,
    allowUnknown: true,
  });
  if (result.error) {
    // エラー表示
    const messages = {};
    _.each(result.error.details, detail => {
      if (detail.type == 'any.empty') {
        setPath(messages, detail.path, '必須です。');
      } else if (detail.type == 'any.required') {
        setPath(messages, detail.path, '必須です。');
      } else if (detail.type == 'string.regex.base') {
        setPath(messages, detail.path, regex.message[detail.context.label]);
      } else if (detail.type == 'string.max') {
        setPath(
          messages,
          detail.path,
          `${detail.context.limit}文字以下で入力してください。`
        );
      } else if (detail.type == 'string.min') {
        setPath(messages, detail.path, '文字数が少ないです');
      } else if (detail.type == 'array.base') {
        setPath(messages, detail.path, 'arrayが必要です。');
      } else if (detail.type == 'string.email') {
        setPath(messages, detail.path, 'メールアドレスが正しくないです');
      } else if (detail.type === 'array.min') {
        setPath(messages, detail.path, '項目数が足りません。');
      } else if (detail.type === 'validation.custom') {
        setPath(messages, detail.path, detail.message);
      }
    });
    return { result: false, messages };
  }

  return { result: true };
};

function setPath(obj, path, value) {
  let key = path;

  if (_.isArray(path)) {
    key = path.shift();

    if (path.length > 0) {
      if (!obj[key]) {
        obj[key] = {};
      }
      return setPath(obj[key], path, value);
    }
  }

  obj[key] = value;
}



// WEBPACK FOOTER //
// ./src/utilities/validation.js